import React from "react";
import { useHistory } from "react-router-dom";

import { Button, Grid } from "@material-ui/core";
import { Edit as EditIcon, ArrowBack } from "@material-ui/icons";

import LayoutHeaderTitle from "components/LayoutHeaderTitle";
import LinkContainer from "components/LinkContainer";
import ItemTitle from "screens/InventoryItemDetail/components/ItemTitle";
import GoToItemHistoryButton from "screens/InventoryItemDetail/components/GoToItemHistoryButton";
import AuthWrapper from "components/AuthWrapper";
import Icon from "components/Icon";
import { useInventoryNavigation } from "contexts/InventoryNavigationContext";

const BackButton = () => {
  const history = useHistory();
  const { getSavedFilters, clearSavedFilters } = useInventoryNavigation();

  const handleBackClick = () => {
    const savedFilters = getSavedFilters();
    
    if (savedFilters && Object.keys(savedFilters).length > 0) {
      const params = new URLSearchParams(savedFilters);
      params.set("restoreCols", "1");
      history.push(`/inventory/items?${params.toString()}`);
      clearSavedFilters();
    } else {
      history.push('/inventory/items?restoreCols=1');
    }
  };

  return (
    <AuthWrapper permission={"ITEMS.ITEMS_READ"}>
      <Grid item>
        <Button
          variant={"outlined"}
          startIcon={<ArrowBack />}
          color={"secondary"}
          style={{ paddingTop: 0, paddingBottom: 0, paddingRight: 16, paddingLeft: 16 }}
          onClick={handleBackClick}
        >
          Back
        </Button>
      </Grid>
    </AuthWrapper>
  );
};

const inventoryItemDetailHeaderComponents = (item) => [
  <Grid item xs={6}>
    <LayoutHeaderTitle titleComponent={<ItemTitle item={item} />} />
  </Grid>,
  <Grid item xs={6}>
    <Grid container justify={"flex-end"} alignItems={"center"} spacing={2}>
      <BackButton />
      <AuthWrapper permission={"ITEMS.ITEMS_CREATE"} clientId={item?.clientId?._id || item?.clientId}>
        <Grid item>
          <LinkContainer
            to={`/inventory/items/clone/${item._id}`}
            Component={(props) => (
              <Button
                {...props}
                variant={"outlined"}
                startIcon={<Icon name={"clone"} />}
                color={"secondary"}
                style={{ paddingTop: 0, paddingBottom: 0, paddingRight: 16, paddingLeft: 16 }}
              >
                Clone item
              </Button>
            )}
          />
        </Grid>
      </AuthWrapper>
      <AuthWrapper permission={"ITEMS.ITEMS_READ_DETAIL_HISTORY"} clientId={item?.clientId?._id || item?.clientId}>
        <Grid item>
          <GoToItemHistoryButton item={item} />
        </Grid>
      </AuthWrapper>
      <AuthWrapper permission={"ITEMS.ITEMS_UPDATE"} clientId={item?.clientId?._id || item?.clientId}>
        <Grid item>
          <LinkContainer
            to={`/inventory/items/edit/${item._id}`}
            Component={(props) => (
              <Button
                {...props}
                variant={"contained"}
                startIcon={<EditIcon />}
                color={"secondary"}
              >
                Edit item
              </Button>
            )}
          />
        </Grid>
      </AuthWrapper>
    </Grid>
  </Grid>
];

export default inventoryItemDetailHeaderComponents;
